{
  "alert": {
    "blurb": "إشعار لجذب انتباه المستخدم.",
    "name": "تنبيه"
  },
  "button": {
    "blurb": "عنصر قابل للنقر ينفذ إجراءً عند الضغط عليه.",
    "default": "افتراضي",
    "loading": "جاري التحميل...",
    "name": "زر",
    "send": "إرسال"
  },
  "components": {
    "name": "المكونات",
    "title": "المكونات"
  },
  "form": {
    "blurb": "عرض توضيحي لجميع مكونات الإدخال المضمنة في هذا القالب.",
    "name": "نموذج",
    "title": "نموذج"
  },
  "orgName": "تطوير Mindsea",
  "title": "ساحة تجريب المكونات"
}
